import type { I18n } from '@aerofruits/i18n';

export class OrientationOverlay {
  private readonly root: HTMLElement;
  private readonly titleEl: HTMLElement;
  private readonly messageEl: HTMLElement;
  private visible = false;

  constructor(root: HTMLElement, i18n: I18n) {
    this.root = root;
    root.classList.add('orientation-overlay');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'orientation-overlay-title');
    root.innerHTML = `
      <div class="orientation-overlay__content">
        <svg class="orientation-overlay__icon" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
          <rect x="18" y="8" width="28" height="48" rx="4" fill="none" stroke="currentColor" stroke-width="2.5"/>
          <path d="M32 18v14M26 28l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2 id="orientation-overlay-title" class="orientation-overlay__title"></h2>
        <p class="orientation-overlay__message"></p>
      </div>`;
    this.titleEl = root.querySelector('.orientation-overlay__title')!;
    this.messageEl = root.querySelector('.orientation-overlay__message')!;
    this.applyTranslations(i18n);
    this.hide();
  }

  applyTranslations(i18n: I18n): void {
    const t = i18n.t.bind(i18n);
    this.titleEl.textContent = t('lnd.orientation.title');
    this.messageEl.textContent = t('lnd.orientation.message');
  }

  show(): void {
    if (this.visible) return;
    this.visible = true;
    this.root.removeAttribute('hidden');
    this.root.dataset.visible = 'true';
  }

  hide(): void {
    if (!this.visible && this.root.hasAttribute('hidden')) return;
    this.visible = false;
    this.root.setAttribute('hidden', '');
    this.root.dataset.visible = 'false';
  }

  isVisible(): boolean {
    return this.visible;
  }
}
